import { Injectable } from "@angular/core";

@Injectable()
export class NumberService {
    round(value: number, decimals: number = 2): number {
        if (isNaN(value)) {
            return 0;
        }
        const factor = Math.pow(10, decimals);
        return Math.round(value * factor) / factor;
    }
}
